import React from 'react';
import DependencyGraph from './DependencyGraph';
import '../styles/components/DependencyGraphPage.css';

const DependencyGraphPage = ({ telegramId }) => {
  return (
    <div className="dependency-graph-page">
      <div className="page-header">
        <h2>Кластер пользователей</h2>
        {/* <p className="page-description">
          Визуальное представление сети приглашений между пользователями системы. 
          Каждый узел представляет пользователя, а линии показывают, кто кого пригласил.
        </p> */}
      </div>
      
      <div className="graph-wrapper">
        <DependencyGraph telegramId={telegramId} />
      </div>
      
      <div className="graph-info">
        <div className="info-card">
          <div className="legend-item">
            <span className="legend-color" style={{ backgroundColor: '#3498db' }}></span>
            <span>Пользователь пригласил других</span>
          </div>
          <div className="legend-item">
            <span className="legend-color" style={{ backgroundColor: '#e74c3c' }}></span>
            <span>Пользователь никого не пригласил</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DependencyGraphPage; 